import { FormikErrors } from 'formik';

import { Resource } from '../../backend';
import {
    isArrivalHallProperties,
    isBoardingGateProperties,
    isCheckInProperties,
    isDepartureHallProperties,
    isParkingProperties,
    isTerminalProperties,
} from '../Resources/ResourceContent/ResourceFields/ResourceFieldsLine/LineContainer/UnsharedProperties/ResourceFieldsLine.utils';
import { ResourcesPageFormValues } from './ResourcesPage';

export const validateResource = (
    index: number,
    r: Resource,
    errors: FormikErrors<ResourcesPageFormValues>,
    values: ResourcesPageFormValues,
) => {
    //name unique and required
    if (!r.id && r.name && values.resources.find((r2, index2) => r2.name === r.name && index2 !== index)) {
        errors[`resources[${index}]['name']`] = 'already used';
    }
    if (!r.id && !r.name) {
        errors[`resources[${index}]['name']`] = 'required';
    }

    //capacity integer and > 1
    if (!Number.isInteger(r.capacity)) {
        errors[`resources[${index}]['capacity']`] = 'must be integer';
    }
    if (r.capacity < 1) {
        errors[`resources[${index}]['capacity']`] = 'must be > 0';
    }

    //minTimeBetweenUse integer and > 0
    if (!Number.isInteger(r.minTimeBetweenUse)) {
        errors[`resources[${index}]['minTimeBetweenUse']`] = 'must be integer';
    }
    if (r.minTimeBetweenUse < 0) {
        errors[`resources[${index}]['minTimeBetweenUse']`] = 'must be positive';
    }

    //occupationOffset integer and > 0
    if (
        (isParkingProperties(r.content) || isTerminalProperties(r.content)) &&
        !Number.isInteger(r.content.occupationOffset)
    ) {
        errors[`resources[${index}]['occupationOffset']`] = 'must be integer';
    }
    if ((isParkingProperties(r.content) || isTerminalProperties(r.content)) && r.content.occupationOffset < 0) {
        errors[`resources[${index}]['occupationOffset']`] = 'must be positive';
    }

    //length > 0
    if (isParkingProperties(r.content) && r.content.length < 0) {
        errors[`resources[${index}]['length']`] = 'must be positive';
    }

    //width > 0
    if (isParkingProperties(r.content) && r.content.width < 0) {
        errors[`resources[${index}]['width']`] = 'must be positive';
    }

    //surface > 0
    if (
        (isTerminalProperties(r.content) ||
            isArrivalHallProperties(r.content) ||
            isDepartureHallProperties(r.content)) &&
        r.content.surface < 0
    ) {
        errors[`resources[${index}]['surface']`] = 'must be positive';
    }

    //passengersBySquareMeter > 0
    if (
        (isTerminalProperties(r.content) ||
            isArrivalHallProperties(r.content) ||
            isDepartureHallProperties(r.content)) &&
        r.content.passengersBySquareMeter < 0
    ) {
        errors[`resources[${index}]['passengersBySquareMeter']`] = 'must be positive';
    }

    //offsetSTA integer and > 0
    if (isArrivalHallProperties(r.content) && !Number.isInteger(r.content.offsetSTA)) {
        errors[`resources[${index}]['offsetSTA']`] = 'must be integer';
    }
    if (isArrivalHallProperties(r.content) && r.content.offsetSTA < 0) {
        errors[`resources[${index}]['offsetSTA']`] = 'must be positive';
    }

    //offsetSTD integer and > 0
    if (isDepartureHallProperties(r.content) && !Number.isInteger(r.content.offsetSTD)) {
        errors[`resources[${index}]['offsetSTD']`] = 'must be integer';
    }
    if (isDepartureHallProperties(r.content) && r.content.offsetSTD < 0) {
        errors[`resources[${index}]['offsetSTD']`] = 'must be positive';
    }

    //paxCapacity integer and > 0
    if (
        (isBoardingGateProperties(r.content) || isCheckInProperties(r.content)) &&
        !Number.isInteger(r.content.paxCapacity)
    ) {
        errors[`resources[${index}]['paxCapacity']`] = 'must be integer';
    }
    if ((isBoardingGateProperties(r.content) || isCheckInProperties(r.content)) && r.content.paxCapacity < 1) {
        errors[`resources[${index}]['paxCapacity']`] = 'must be > 1';
    }
};
